import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Home from './Home';
import Climbing from './Climbing';
import RopeAccess from './RopeAccess';
import Development from './Development';
import './App.css';
import logo from './logo.svg';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const closeMenu = () => setIsMenuOpen(false);
    window.addEventListener('resize', closeMenu);
    return () => window.removeEventListener('resize', closeMenu);
  }, []);

  return (
    <Router>
      <div className={`App ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <header>
          <div className="logo">
            <img src={logo} alt="M" />
            <h1>Vertical Ventures</h1>
          </div>
          <button onClick={toggleTheme} className="theme-toggle">
            {isDarkMode ? '☀️' : '🌙'}
          </button>
          <button className="menu-toggle" onClick={toggleMenu}>
            ☰
          </button>

          <nav className={isMenuOpen ? 'open' : ''}>
            <ul>
              <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
              <li><Link to="/climbing" onClick={() => setIsMenuOpen(false)}>Climbing</Link></li>
              <li><Link to="/rope-access" onClick={() => setIsMenuOpen(false)}>Rope Access</Link></li>
              <li><Link to="/development" onClick={() => setIsMenuOpen(false)}>Development</Link></li>
            </ul>
          </nav>

        </header>

        <main onClick={() => setIsMenuOpen(false)}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/climbing" element={<Climbing />} />
            <Route path="/rope-access" element={<RopeAccess />} />
            <Route path="/development" element={<Development />} />
          </Routes>
        </main>

        <footer>
          <p>&copy; 2023 Vertical Ventures. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;